// ** React Imports
import { useEffect, useState } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'

// ** Custom Components
import CustomChip from 'src/materio/@core/components/mui/chip'

// ** Types
import { ThemeColor } from 'src/materio/@core/layouts/types'

import { MissingData, LeadScreenStore, ViewType, HotLeadStore, LeadListStore, DashboardViewStore } from "src/stores/LeadStore";
import { red } from '@mui/material/colors'
import TrendingUpTwoToneIcon from '@mui/icons-material/TrendingUpTwoTone';
import TrendingDownTwoToneIcon from '@mui/icons-material/TrendingDownTwoTone';
import { inherits } from 'util'
import LocalFireDepartmentTwoTone from '@mui/icons-material/LocalFireDepartmentTwoTone';
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import { client } from '../../utils/axios-client'
import { getLeadEndpoint, leadEndpoints } from '../../configs/endpoints'
import TrendingFlatTwoToneIcon from '@mui/icons-material/TrendingFlatTwoTone';
import _ from 'lodash'
import Link from '@mui/material/Link'


interface Props {
    totalActivities: number,
    labelText: string,
    diffType: string,
    totalDifference: number,
    comparedTo: string,
    activityDate: string,
    activityType: string
}

const PerformanceCard = ({ totalActivities, labelText, diffType, totalDifference, comparedTo, activityDate, activityType }: Props) => {

    const handleSelection = () => {
        DashboardViewStore.update(s => { s.activityDate = activityDate });
        DashboardViewStore.update(s => { s.activityType = activityType });
        DashboardViewStore.update(s => { s.customerId = '' });
        DashboardViewStore.update(s => { s.activityHistoryTitle = labelText + getDateTypeTitleText(activityDate) });

        DashboardViewStore.update(s => { s.showTodoList = false });
        DashboardViewStore.update(s => { s.showActivityWorkList = false });
        DashboardViewStore.update(s => { s.showInboundCallList = false });
        DashboardViewStore.update(s => { s.showActivityHistoryList = true });
        DashboardViewStore.update(s => { s.showDefault = false });
        DashboardViewStore.update(s => { s.showDetail = true });
        DashboardViewStore.update(s => { s.showTaskList = false });

    };

    const getDateTypeTitleText = (activityDate: string) => {

        switch (activityDate) {
            case "today":
                return " for Today"
            case "thisweek":
                return " for This Week"
            case "thismonth":
                return " for This Month"
            default:
            // code block
        }
       

    };


    return (
        <Grid container spacing={2} justifyContent={'center'} paddingTop={4} paddingBottom={3} >
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }} >
                <Tooltip title='Click to view activities'>
                    <Link
                        underline="hover"
                        component="button"
                        sx={{ fontSize: 30, color: 'CornflowerBlue' }}
                        onClick={() => handleSelection()}
                    >
                        {totalActivities}
                    </Link>
                </Tooltip>
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }} >
                <Tooltip title='Click to view activities'>
                    <Link
                        underline="hover"
                        component="button"
                        sx={{ fontSize: 16, color: 'CornflowerBlue' }}
                        onClick={() => handleSelection()}
                    >
                        {labelText}
                    </Link>
                </Tooltip>
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }} >
                {diffType == "less" &&
                    <Tooltip title={'Downward trend'} >
                        <Typography sx={{ fontSize: 12, color: 'red' }} >
                            {totalDifference} Compared to {comparedTo}
                        </Typography>
                    </Tooltip>
                }
                {diffType == "more" &&
                    <Tooltip title={'Upward trend'} >
                        <Typography sx={{ fontSize: 12, color: 'green' }} >
                            +{totalDifference} Compared to {comparedTo}
                        </Typography>
                    </Tooltip>
                }
                {diffType == "same" &&
                    <Tooltip title={'No trend change'} >
                        <Typography sx={{ fontSize: 12, color: 'orange' }} >
                            Same as {comparedTo}
                        </Typography>
                    </Tooltip>
                }
            </Grid>
            <Grid item xs={12} sx={{ pt: 2, display: 'flex', alignItems: 'center', flexDirection: 'column' }} >
                {diffType == "less" &&
                    <Tooltip title={'Downward trend'} >
                        <TrendingDownTwoToneIcon sx={{ color: 'red' }} />
                    </Tooltip>
                }
                {diffType == "more" &&
                    <Tooltip title={'Upward trend'} >
                        <TrendingUpTwoToneIcon sx={{ color: 'green' }} />
                    </Tooltip>
                }
                {diffType == "same" &&
                    <Tooltip title={'No trend change'} >
                        <TrendingFlatTwoToneIcon sx={{ color: 'orange' }} />
                    </Tooltip>
                }
            </Grid>
        </Grid>
    )

}

export { PerformanceCard }
export default PerformanceCard